'use strict';

var GridToolbarDefaultDirective = function GridToolbarDefaultDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/grid-toolbar-default.html')
  };
};
GridToolbarDefaultDirective.$inject = [];
module.exports = GridToolbarDefaultDirective;